/**************************************************
 * Nombre:       Formulario_Movimientos_Crear
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    CalendarMonth,
    EmojiFlagsOutlined,
    Flag,
    FlagCircleOutlined,
    Google,
    MoneyOutlined,
    NumbersOutlined,
    QrCode2Outlined, TaskOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {ESTADOSMOVIMIENTO, TIPOMONEDA, TIPOSCONTRATO, TIPOSMOVIMIENTO, VISIBILIDADMOVIMIENTO} from "../../Constantes";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {getID} from "../../Servicios/BD/useEscucharUsuarioToCorreo";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../Recursos/logo_redondo.svg";
import IngresoFechaHora from "../../Modulo_formularios/Componentes/IngresoFechaHora";

const Formulario_Movimientos_Crear = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos de Usuario</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto nombre={'Correo de usuario'} {...props} dato={'correo'} Icono={Google}
                                        editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre de Usuario'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={TaskOutlined} nombre={'Id Contrato'} dato={'idEscogido'} {...props}
                                  requerido={'El Id del contrato es requerido'} opciones={[...props.opciones, 'Ninguno']}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos de Movimiento</Typography>
                </Grid>


                <Grid container size={6}>
                    <IngresoSelect Icono={FlagCircleOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                                   opciones={TIPOSCONTRATO.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Visibilidad'} dato={'visible'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={VISIBILIDADMOVIMIENTO.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoSelect Icono={EmojiFlagsOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSMOVIMIENTO}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor (puede ser negativo)'} dato={'valor'} {...props}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Notas para Usuario'} dato={'detalle'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Movimientos_Crear